export default __webpack_public_path__ + "static/media/968.f20994e0.png";